import ContractRoute from './ContractRoute'

const routes = [
    new ContractRoute()
]

export default routes